export class DropDown {
  constructor(/** jQuery */el) {
    const $this = this;

    /** @type {jQuery} */
    this.dd = el;
    this.placeholder = this.dd.children('span.choose-selected');
    this.container = this.dd.find('ul.dropdown');
    this.opts = this.container.find('> li');
    this.val = '';
    this.selectedVal = this.dd.children('input.choose-value');
    this.index = -1;

    let lastIndex = -1;
    let lastKey = '';
    let $lastFocused;

    this.dd.on('click', () => {
      console.log(this.dd);
      //this.dd.toggleClass('active');

      $lastFocused = null;
      lastIndex = -1;
      lastKey = '';

      this.opts.removeClass('focused');

      return false;
    });

    this.opts.on('click', function () {
      const opt = $(this);
      console.log(opt);
      $this.val = opt.text();
      $this.index = opt.index();
      $this.placeholder.text($this.val);
      if ($this.selectedVal != null)
      {
        $this.selectedVal.val(opt.data('value'));
        $this.selectedVal.trigger('change');
      }
    });

    this.dd.on('keypress', (event) => {
      const key = event.key.toUpperCase();

      if (event.keyCode === 13)
      {
        if ($lastFocused)
        {
          $lastFocused.trigger('click');
        }

        return;
      }

      const $items = this.container.find(`li[data-value^="${key}"]`);

      this.opts.removeClass('focused');

      lastIndex = Math.max(0, (lastKey !== key) ? 0 : Math.min(lastIndex + 1, $items.length - 1));

      const $item = $items.eq(lastIndex);
      if ($item.length)
      {
        $lastFocused = $item;
        $item.addClass('focused');
        const top = $lastFocused.get(0).offsetTop;
        this.container.animate({scrollTop: top}, 500);
      }

      lastKey = key;
    });
  }

  getValue() {
    return this.val;
  }

  getIndex() {
    return this.index;
  }
}

export function dropdown() {
  $(document).on('click', () => {
    $('.wrapper-dropdown').removeClass('active');
    $('.wrapper-dropdown .dropdown li').removeClass('focused');
  });
}
